<template>
<div style="width:100%;overflow:hidden;margin-top:10px;">
  <swiper ref="awesomeSwiper" :options="swiperOption">
    <swiper-slide  v-for="item in list" :key="item.id"> <div class="car-item">
        <div class="car-header">
          <span class="car-carno">{{item.proviceCarno}}</span>
          <span class="car-carno-btn" @click="editcar(item)">编辑车辆</span>
        </div>
        <div class="car-footer">
          <p>
            <span>未完成交通违法</span>
            <span class="car-footer-num">{{illegal.total || 0}}</span>条,
            <span>扣分</span>
            <span class="car-footer-num">{{illegal.degree || 0}}</span>分,
            <span>罚款</span>
            <span class="car-footer-num">{{illegal.fine || 0}}</span>元
          </p>
        </div>
      </div></swiper-slide>
      <swiper-slide>
        <div class="car-item car-add" @click="$emit('on-swiper-add')" >
          <img src="../assets/icon/car_add.png"
          style="width: 42px;height: 42px;display:block;margin:0 auto 10px;"  />
          <div class="car-add-text">点击添加车辆查询违章</div>
        </div>
      </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
  </div>
</template>

<script>
/** ***
 *        <!-- 有爱车列表 轮播 start -->
      <swiper :list="carList" @on-swiper-change="onSwiperChange"
      :illegal="illegal" @on-swiper-add="onSwiperAdd" />
      <!-- 有爱车列表 轮播 end -->
 */
import { swiper, swiperSlide } from 'vue-awesome-swiper';

import 'swiper/dist/css/swiper.min.css';//eslint-disable-line

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    illegal: {
      type: Object,
      default: () => {},
    },
  },
  // mounted() {
  //   console.log(this.list, this.swiper, 'mounted');
  // },
  updated() {
    if (this.illegal.CarNo) {
      this.list.forEach((item, index) => {
        if (this.illegal.CarNo === item.proviceCarno) {
          this.swiper.slideTo(index, 500, false);
        }
      });
    }

  },
  // activated() {
  //   console.log(this.list, this.swiper, 'activated');
  // },
  computed: {
    swiper() {
      return this.$refs.awesomeSwiper.swiper;
    },
  },
  data() {
    return {
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        pagination: {
          el: '.swiper-pagination',
        },
        on: {
          slideChange: () => {
            this.$emit('on-swiper-change', this.swiper.activeIndex);
          },
          // slideChange(index) {
          //   console.log(this, index);
          //   // this.$emit('on-swiper-change', index);
          // },
        },

      },
    };
  },
  methods: {
    editcar(carinfo) {
      console.log(carinfo,'=+=')
      this.$router.push({
        name: 'addcar',
        query: { ...carinfo, redirect: '/' },
      });
      // console.log(...carinfo,'编辑车辆')




    },

  },
};
</script>

<style scoped>
.swiper-container {
  overflow: visible;
  margin-bottom: 35px;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 83%;
  border-radius: 2px;
  overflow: hidden;
  /* width: 300px; */
  /* height: 300px; */
}
.swiper-container-horizontal>.swiper-pagination-bullets,
.swiper-pagination-custom, .swiper-pagination-fraction {
  bottom: -30px;
}
.car-item {
  box-shadow: 0 5px 12px 0 rgba(58, 130, 255, 0.15);
  /* margin-right: 10px; */
  /* width: 97%; */
  margin: 0 auto;
  background-color: #fff;
  /* box-shadow: 0 2px 4px 0 #EFEFEF; */
  border-radius: 2px;
  font-size: 13px;
  height: 96px;
  /* border-right:1px solid #fff; */
}
.car-header {
  background-image: url("../assets/icon/ibg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
  display: flex;
  align-items: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  height: 50%;
  padding: 0 14px;
}

.car-footer {
  height: 50%;
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #24252d;
  /* justify-content: space-between; */
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  padding: 0 14px;

}

.car-footer-num {
  margin:0 3px;
  color: #3a82ff;
}
.car-carno {
  font-size: 20px;
  flex: 1;
  font-weight: 500;
}
.car-carno-btn {
  font-size: 12px;
  color: #eaf0ff;
}
.car-add {
  padding: 12px 0;
  text-align: center;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0 5px 12px 0 rgba(58, 130, 255, 0.15);
  border-radius: 2px;
  border: 1px #3a82ff dashed;
}
.car-add-btn {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: linear-gradient(-133deg, #4162ff 0%, #537eff 100%);
  font-size: 34px;
  font-weight: 200;
  color: #fff;
  line-height: 34px;
  margin: 0 auto;
  text-align: center;
  /* border:1px solid #DDDDDD; */
  margin-bottom: 10px;
}
.car-add-text {
  display: inline-block;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  margin-left: 10px;
  color: #24252d;
}
</style>
